import { FC } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormHelperText from '@mui/material/FormHelperText';
import { styled } from '@mui/material/styles';
import { Column } from '../Layout';
import Dropzone, { DropzoneProps } from './Dropzone';
import FileList, { FileListProps } from './FileList';
import FileRestrictionDetail, {
  FileRestrictionDetailProps,
} from './FileRestrictionDetail';

const ImageWrapper = styled(Box)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  borderColor: theme.palette.borderColor.main,
  borderStyle: 'solid',
  borderWidth: '1px',
  padding: theme.spacing(3, 3),
}));

const InputTitleTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[900],
}));

const StyledFormHelperText = styled(FormHelperText)({
  padding: 0,
  margin: 0,
});

export type FileDropProps = {
  inputTitle?: string;
  error?: boolean;
  helperText?: string;
  name?: string;
} & FileRestrictionDetailProps &
  FileListProps &
  DropzoneProps;

const FileDrop: FC<FileDropProps> = ({
  inputTitle,
  supportedFormats,
  files,
  sizeRestriction,
  maxFiles,
  disabled,
  onDeleteFile,
  onDropFile,
  name,
  error,
  helperText,
}) => {
  const isUploading = Boolean(files?.some((file) => file.isUploading));
  return (
    <ImageWrapper>
      <Column spacing="sm">
        {inputTitle ? (
          <InputTitleTypography variant="body2">
            {inputTitle}
          </InputTitleTypography>
        ) : null}
        <Dropzone
          name={name}
          maxFiles={maxFiles}
          sizeRestriction={sizeRestriction}
          disabled={isUploading || disabled}
          supportedFormats={supportedFormats}
          onDropFile={onDropFile}
        />
        {files?.length ? (
          <FileList files={files} onDeleteFile={onDeleteFile} />
        ) : null}
        {sizeRestriction || supportedFormats?.length ? (
          <FileRestrictionDetail
            sizeRestriction={sizeRestriction}
            supportedFormats={supportedFormats}
          />
        ) : null}
        {helperText ? (
          <StyledFormHelperText error={error}>
            {helperText}
          </StyledFormHelperText>
        ) : null}
      </Column>
    </ImageWrapper>
  );
};

export default FileDrop;
